import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/tursab-dvs-7677.webp")